import { CheckCircle, Visibility } from "@mui/icons-material";
import { IconButton, Paper, Tooltip, Typography } from "@mui/material";
import { MaterialReactTable, MRT_ToggleDensePaddingButton, MRT_ToggleFiltersButton, MRT_ToggleFullScreenButton, useMaterialReactTable } from "material-react-table";
import { useMemo } from "react";
import { dateAccesor } from "../../../commons/table/columns/accesors";
import { localization, tableConfig } from "../../../commons/table/config/tableConfig";

const XmlNewsTable = ({
    handleVisualizarXml,
    handleOpenConfirmDialog,
    data,
    loading,
    rowSelection,
    setRowSelection,
}) => {
    const columns = useMemo(() => ([
        {
            header: "Art",
            accessorKey: "artNombre",
        },
        {
            header: "Id Xml Prestador",
            accessorKey: "idXmlPrestador",
        },
        {
            header: "Fecha Ingreso Novedad",
            accessorKey: "fechaHoraIngreso",
            accessorFn: dateAccesor("fechaHoraIngreso"),
            filterFn: "date",
        },
        {
            header: "Inicio Proceso",
            accessorKey: "inicioProceso",
            Cell: ({ cell }) => cell.getValue() ? "1" : "0",
        },
        {
            header: "Fecha Hora Procesado",
            accessorKey: "fechaHoraProcesado",
            accessorFn: dateAccesor("fechaHoraProcesado"),
            filterFn: "date"
        }
    ]), []);

    const table = useMaterialReactTable({
        ...tableConfig,
        data: data || [],
        columns: columns,
        getRowId: (originalRow, index) => {
            return originalRow.idXmlPrestador?.toString()
        },
        state: { isLoading: loading, rowSelection },
        enableRowActions: true,
        renderRowActions: ({ row }) => (
            <>
                <Tooltip title={"Visualizar XML"}>
                    <IconButton
                        onClick={() => handleVisualizarXml(row.original.idXmlPrestador)}
                    >
                        <Visibility
                            size="small"
                            color="inherit"
                        />
                    </IconButton>
                </Tooltip>
            </>
        ),
        positionActionsColumn: "last",
        onRowSelectionChange: setRowSelection,
        enableSelectAll: true,
        enableRowSelection: true,
        enableColumnOrdering: false,
        renderToolbarInternalActions: ({ table }) => {
            return (
                <>
                    {table.getSelectedRowModel().rows.length > 0 && (
                        <Tooltip title="Procesar XMLs Seleccionados">
                            <IconButton
                                sx={{ color: "secondary.main", marginLeft: 'auto' }}
                                onClick={() => handleOpenConfirmDialog()}
                            >
                                <CheckCircle />
                            </IconButton>
                        </Tooltip>
                    )}
                    <MRT_ToggleFiltersButton table={table} />
                    <MRT_ToggleDensePaddingButton table={table} />
                    <MRT_ToggleFullScreenButton table={table} />
                </>
            )
        },
        muiTableBodyCellProps: localization.cells,
        layoutMode: "grid",
    });

    return (
        <Paper style={{ width: '100%' }}>
            <Typography variant="h6" sx={{ padding: 2 }}>
                Novedades XML
            </Typography>
            <MaterialReactTable table={table} />
        </Paper>
    );
};

export default XmlNewsTable;